import React from 'react';
// common import
import Breadcrumbs from '../../../../common/components/Breadcrumbs/Breadcrumbs';
// data
import Data from '../../../../model/Data';
// styles
import './Header.css'

interface Props {
  className?: string;
}

class Header extends React.Component<Props, { id: number }> {
  render(): JSX.Element {
    return (
      <div className="about-header">
        <div className="about-header__inner container">
          <Breadcrumbs brand={Data.Instance.company} items={[]}/>
          <div className="title-container">
            <h1 className="bold">О нас</h1>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
